<template>
  <div id="existing-user">
    <div v-if="!needHelp">
      <p class="alertMsg">
        <span v-if="isSaUser"
          >Our records indicate that you already have access to the myCFM Portal, your username is the email address you
          just entered.</span
        >
        <span v-else>Our records indicate that you already have access to this portal.</span>
      </p>
      <div class="action-btns">
        <button type="button" class="btn btn-sm btn-link" @click.prevent="showNeedHelp">Need Help?</button>
        <a :href="additionalAccessURL" target="_blank" class="btn btn-sm btn-default">Get Additional Access</a>
        <a :href="resetPasswordURL" target="_blank" class="btn btn-sm btn-default">Reset Password</a>
        <input type="button" class="btn btn-sm btn-primary" value="Forgot Username" @click="requestForgotUserId" />
      </div>
    </div>

    <inquiry-form v-if="needHelp" id="need-help" @close-inquiry="closeNeedHelp" />

    <modal v-model="forgotUserIdModal" effect="fade" width="40%">
      <div slot="modal-header" class="modal-header"><strong class="modal-title">Email Sent</strong></div>
      <div>
        An email has been sent to the registered email. Please check your inbox.
        <span class="fa fa-check-circle text-success fa-lg" />
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button id="forgotUser" type="button" class="btn btn-sm btn-primary" @click="forgotUserIdModal = false">
          OK
        </button>
      </div>
    </modal>

    <!-- notificatio failure -->
    <modal v-model="registrationFailed" effect="fade" width="40%">
      <div slot="modal-header" class="modal-header"><strong class="modal-title">Message</strong></div>
      <div>
        <span class="fa fa-exclamation text-warning fa-lg" />
        Your request could not be submitted due to an intermittent connection issue! Please try submitting your request
        again after sometime.
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button id="forgotUser" type="button" class="btn btn-sm btn-primary" @click="regFailed()">
          OK
        </button>
      </div>
    </modal>

    <spinner v-model="showSpinner" size="md" />
  </div>
</template>
<script>
import inquiryForm from "@/mycfm/components/InquiryForm";
import { forgotUserId } from "@/services/endpointsService";
import modal from "build-ui-x/src/Modal";
import spinner from "build-ui-x/src/Spinner";
import { mapState } from "vuex";

export default {
  components: {
    inquiryForm,
    modal,
    spinner
  },
  data() {
    return {
      showSpinner: false,
      needHelp: false,
      forgotUserIdModal: false,
      resetPasswordURL: "",
      additionalAccessURL: "",
      registrationFailed: false
    };
  },
  computed: {
    ...mapState("user", ["user", "portalName"]),
    isSaUser() {
      return this.$store.state.user.user.mdmOrgZone == "SA";
    }
  },
  created() {
    //updating the additionalAccessURL
    if (this.isSaUser) {
      this.additionalAccessURL =
        "https://mycfmportals.uservoice.com/knowledgebase/articles/1886245-how-do-i-request-additional-access-to-widgets-and";
    } else {
      this.additionalAccessURL =
        "https://helpcenter.mycfmportal.com/myCFMFAQ/s/article/How-do-I-request-additional-access-to-Widgets-and-Links-mycfm";
    }

    //Updating resetPasswordURL
    let isGEUser = this.user.email.toLowerCase().endsWith("@ge.com");
    let mdmOrgZone = this.user.mdmOrgZone;
    if (isGEUser) {
      this.resetPasswordURL = "https://mypassword.ge.com/fp/forgetPassword.xhtml";
    } else if (!isGEUser && mdmOrgZone == "INC") {
      this.resetPasswordURL = "https://nextgen.ge-registrar.com/b2bregistration/index.html#/forgotpassword";
    } else {
      this.resetPasswordURL = "https://qa.fedsnecma.snecma.com/PmReinitPwd/rcpInit.jsp";
    }
  },
  methods: {
    regFailed() {
      this.registrationFailed = false;
      window.location.reload();
    },
    showNeedHelp() {
      this.needHelp = true;
    },
    closeNeedHelp() {
      this.needHelp = false;
    },
    requestForgotUserId() {
      this.showSpinner = true;

      forgotUserId(this.user.email)
        .then(data => {
          if (data.success) {
            this.forgotUserIdModal = true;
          }
        })
        .catch(() => {
          this.registrationFailed = true;
        })
        .finally(() => {
          // hide spinner
          this.showSpinner = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
#existing-user {
  margin-top: 25px;
}
.alertMsg {
  color: #ac4d4c;
  font-weight: bold;
}
</style>
